{
    "ENV": {
        "TITLE": "DAF | Test",
        "API": "https://test.api.daf.werkbaarbeter.net",
        "WEBSOCKET": "https://test.api.daf.werkbaarbeter.net/socket",
        "QR_LOGIN": "",
        "QR_LOGIN_REFRESH_RATE": "",
        "QR_LOGIN_CHECK_RATE": "",
        "MSAL_CLIENT_ID": "6dd11a7d-d362-4ff5-890f-0e934b2ca24a",
        "MSAL_TENANT_ID": "6137e509-173d-4076-afc4-67b476042cf9",
        "MSAL_AUTHORITY": "",
        "MSAL_KNOWN_AUTHORITIES": "",
        "HAS_VIDEO": "",
        "MAP_KEY": "",
        "MAP_ID": "",
        "DEBUG": "",
        "EMAIL_LOGIN": ""
    }
}